module.exports = "/fonts/RistrettoPro-Regular.woff";